export default {"src":"/_next/static/media/caminho-giv.eb0d39e1.svg","height":28,"width":27,"blurWidth":0,"blurHeight":0};